import { render } from "./ThankyoumbaView.vue?vue&type=template&id=c35cb8b4"
import script from "./ThankyoumbaView.vue?vue&type=script&lang=js"
export * from "./ThankyoumbaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__